import { render, staticRenderFns } from "./CircusPhysicalTheatre.vue?vue&type=template&id=befb57ca&scoped=true&"
import script from "./CircusPhysicalTheatre.vue?vue&type=script&lang=js&"
export * from "./CircusPhysicalTheatre.vue?vue&type=script&lang=js&"
import style0 from "./CircusPhysicalTheatre.vue?vue&type=style&index=0&id=befb57ca&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befb57ca",
  null
  
)

export default component.exports